import RichText from '@propertypal/web-ui/src/rich-text/RichText';
import styled from 'styled-components';

export const Container = styled.div`
  background: ${(props) => props.theme.backgroundLightest};
  padding: 70px 60px;
  text-align: center;
`;

export const Email = styled.a`
  color: ${(props) => props.theme.primary};
  text-decoration: underline;

  &:hover {
    color: ${(props) => props.theme.backgroundMid};
  }
`;

export const MainText = styled(RichText)`
  font-size: 18px;
  max-width: 580px;
  padding-top: 12px;
  margin: auto;
  text-align: center;
`;
